import React from "react";
import { useNavigate } from "react-router-dom";

export default function ServiceSection() {

	const navigate = useNavigate();

	const handleClick = () => {
		navigate("/services");
	};

	return (
		<>
			<div className="service-section-container mb-5 px-2">
				<div className="service-section-about">
					<div className="row align-items-center justify-content-center">

						<div className="col-md-6 text-center mb-4 mb-md-0 order-1 order-md-1" data-aos="fade-right">
							<img
								src="/assets/images/aboutus/aboutus_service.jpg"
								alt="service"
								className="img-fluid about-service-image"
								style={{ aspectRatio: "1.1/1", objectFit: "cover" }}
							/>
						</div>

						<div className="service-section-right col-md-6 text-center mb-4 mb-md-0 order-2 order-md-2" data-aos="fade-left">
							<h2 className="section-subtitle text-primary">
								We Go Beyond Manufacturing <br /> and Supply
							</h2>
							<p className="description text-primary">
								Modern businesses require modern solutions.
								With the rapidly changing nature of commerce infrastructure and swift integration of technology throughout business pipelines,
								we ensure that we can give the right support to modern businesses.
							</p>
							<div className="text-center">
								<button className="aboutusBtns bg-primary" onClick={handleClick}>Discover Our Services</button>
							</div>
						</div>

					</div>
				</div>
			</div>
		</>
	);
}